export default __webpack_public_path__ + "static/media/cryptos.090a0acb.svg";